/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialCompaniesResponsePaging } from '../../models/editorial-companies-response-paging';

export interface GetEditorialCompanies$Params {
  page: number;
  pageSize: number;
  orderBy?: string;
  filter?: string;
}

export function getEditorialCompanies(http: HttpClient, rootUrl: string, params: GetEditorialCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCompaniesResponsePaging>> {
  const rb = new RequestBuilder(rootUrl, getEditorialCompanies.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialCompaniesResponsePaging>;
    })
  );
}

getEditorialCompanies.PATH = '/api/editorial/companies';
